import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Marco Bianchi',
  role: 'Docente di Informatica, ITIS',
  city: 'Milano',
  text: 'Prima passavo i weekend a preparare slide e cercare esercizi su Python che non fossero banali. Con questo Kit ho letteralmente smesso di pianificare a casa. Apro il tomo, seguo la progressione e gli studenti sono molto più ingaggiati. I progetti pratici sono fantastici.'
}, {
  name: 'Giulia Ferrari',
  role: 'Docente di Informatica, IPSIA',
  city: 'Bologna',
  text: "La vera svolta per me è stata la sezione sui BES e DSA. Avere strategie già pronte per adattare il materiale mi ha salvato la vita in una classe molto eterogenea. I ragazzi capiscono meglio grazie all'approccio visivo e io arrivo a scuola molto più serena."
}, {
  name: 'Alessandro Romano',
  role: 'Docente Tecnico Pratico',
  city: 'Napoli',
  text: 'Insegno laboratorio e spesso i ragazzi si perdevano nella teoria. Il Tomo 5 su HTML/CSS è strutturato in modo perfetto: mobile-first da subito, niente concetti obsoleti. In 5 minuti so esattamente cosa far fare loro per le successive 2 ore.'
}, {
  name: 'Francesca Greco',
  role: 'Docente di Informatica, ITIS',
  city: 'Torino',
  text: 'Ero scettica, ma per 19,90€ ho voluto provare. È il miglior investimento della mia carriera. La programmazione annuale già scritta (Bonus 1) mi ha fatto risparmiare giorni di lavoro a settembre. Totalmente allineato al MIUR, lo consiglio a tutti i colleghi.'
}, {
  name: 'Luca Esposito',
  role: 'Docente di Informatica',
  city: 'Roma',
  text: 'Finalmente un materiale che non tratta gli studenti come bambini ma li porta a un livello professionale. Le rubriche di valutazione incluse mi hanno risolto il problema di come dare voti oggettivi sui progetti pratici. Vale almeno 10 volte il prezzo che costa.'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-224">
      <div className="max-w-6xl mx-auto" data-id="element-225">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-8 uppercase text-brand-cream" data-id="element-226">
          Cosa dicono i colleghi
        </motion.h2>

        <div className="grid grid-cols-1 gap-4" data-id="element-227">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/5 p-6 rounded-2xl flex flex-col" data-id="element-228">
              <div className="flex text-brand-gold mb-4" data-id="element-229">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-230" />)}
              </div>
              <p className="text-gray-300 font-medium italic mb-6 flex-grow" data-id="element-231">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-232">
                <div className="font-bold text-brand-cream" data-id="element-233">{t.name}</div>
                <div className="text-sm text-brand-orange" data-id="element-234">{t.role}</div>
                <div className="text-xs text-gray-500 mt-1" data-id="element-235">{t.city}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}